module.exports = __webpack_public_path__ + "img/a1.86156cdb.jpg";